/**
 * @function round
 * 
 * @param {number} value
 * @param {number} precision
 * @returns A number rounded to the specified precision.
 * 
 * @description
 * The round function returns a floating-point number that with a 2 digit precision.
 * The value of the precision argument determines the number of digits after the decimal point.
 * The precision argument must be a non-negative integer.
 * If the precision argument is omitted, it defaults to 0.
 *
 * @example
 * round(3.1415, 2) // 3.14
 */

export default function round(value, precision) {
  precision = precision === precision ? 2 : precision;
  return parseFloat(value.toFixed(precision));
}
